import React, { useEffect } from 'react';
import { Spinner } from '../../../../../common/index.jsx';
import PageForm from './PageForm.jsx';
import { routes } from '../../../../../../utils/helpers/ApiClient.jsx';
import { AppBarCMS } from '../../../../../basic/index.jsx';
import Form from '../../../../../antd/form/Form/Form.jsx';
import {
  useGetWikiCategoriesQuery,
  useGetWikiPageItemQuery,
  useSaveWikiPageMutation,
} from '../../../../../../redux/services/wikiApi.jsx';
import { useNavigate, useParams } from 'react-router-dom';
import { useToastMessages } from '../../../../../../hooks/useToastMessages.jsx';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { ROLE_WIKI_ADMIN } from '../../../../../../utils/constants/roles.js';
import { showErrorPage } from '../../../../../../redux/slices/coreSlice.jsx';

const PageEdit = ({ mode }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { id } = useParams();
  const { t } = useTranslation();
  const user = useSelector((state) => state.auth.user);

  const { data: wikiPageItem, isLoading: isWikiPageItemLoading } =
    useGetWikiPageItemQuery(id);
  const { data: wikiCategories } = useGetWikiCategoriesQuery();
  const { saveSuccess: toastSaveSuccess } = useToastMessages();

  const [saveWikiPageItem] = useSaveWikiPageMutation();

  const isCreate = mode === 'create';
  const isEdit = mode === 'edit';
  const isWikiAdmin =
    user?.roles?.some((role) => role.name === ROLE_WIKI_ADMIN) ?? false;
  const isAuthor = wikiPageItem?.person_id === user?.id;
  const canEditWikiPage = isWikiAdmin || isAuthor;
  const pageTitle = isCreate
    ? t('Pridanie Wiki stránky')
    : t('Úprava Wiki stránky');

  useEffect(() => {
    if (!isEdit || isWikiPageItemLoading || !wikiPageItem) {
      return;
    }

    if (!canEditWikiPage) {
      dispatch(
        showErrorPage({
          status: 403,
          message: t('Chýbajúce oprávnenia'),
        }),
      );
    }
  }, [
    canEditWikiPage,
    dispatch,
    isEdit,
    isWikiPageItemLoading,
    t,
    wikiPageItem,
  ]);

  if (isEdit && (!wikiPageItem || isWikiPageItemLoading)) {
    return <Spinner />;
  }

  if (isEdit && !canEditWikiPage) {
    return <Spinner />;
  }

  const initials = {
    title: null,
    content: null,
    wiki_category_id: null,
    ...wikiPageItem,
  };

  const handleSubmit = async (values) => {
    try {
      const payload = isCreate ? values : { ...values, id };
      await saveWikiPageItem(payload).unwrap();
      toastSaveSuccess();
      navigate(routes.cmsWikiPages);
    } catch (err) {
      if (err?.status === 403) {
        dispatch(
          showErrorPage({
            status: 403,
            message: t('Chýbajúce oprávnenia'),
          }),
        );
      }
    }
  };

  return (
    <>
      <AppBarCMS
        title={pageTitle}
        backUrl={routes.cmsWikiPages}
        backUrlTooltip={t('FRI.wiki')}
        permissionsBasic={'wiki-pages'}
      />
      <div style={{ margin: '10px' }}>
        <Form initialValues={initials} onFinish={handleSubmit}>
          <PageForm wikiCategories={wikiCategories} />
        </Form>
      </div>
    </>
  );
};

export default PageEdit;
